{
  "success": {
    "analyses/setMovable": "Updated analysis",
    "analyses/moveIntoPlan": "Successfully moved analysis into plan",
    "analyses/remove": "Unplanned analysis successfully",
    "analysisDefinitions/create": "Added new analysis definition",
    "analysisDefinitions/edit": "Edited analysis definition",
    "analysisDefinitions/remove": "Deleted analysis definition",
    "analysisDraft/create": "Added new analysis draft",
    "analysisDraft/edit": "Edited analysis draft",
    "samples/delete-unlocked": "Deleted all unplanned samples",
    "assets/remove": "Successfully deleted instrument",
    "assets/create": "Added new instrument",
    "assets/edit": "Edited instrument",
    "competenceGroups/create": "Successfully created new competence group",
    "competenceGroups/edit": "Successfully edited competence group",
    "competenceGroups/remove": "Successfully deleted competence group",
    "iap/run": "Successfully ran IAP",
    "iap/runFillInSamples": "Successfully filled in samples",
    "integrationSheets/createActionSheet": "Added sheet",
    "integrationSheets/createProjectTemplateSheets": "Added sheet",
    "integrationSheets/createSampleSheet": "Added sheet",
    "integrationSheets/editActionSheet": "Edited sheet",
    "integrationSheets/editProjectTemplateSheet": "Edited sheet",
    "integrationSheets/editSampleSheet": "Edited sheet",
    "integrationSheets/removeActionSheet": "Deleted sheet",
    "integrationSheets/removeProjectTemplateSheet": "Deleted sheet",
    "integrationSheets/removeSampleSheet": "Deleted sheet",
    "integrationSheets/saveSapConversionSheet": "Saved Project Import sheet",
    "members/create": "Added member",
    "members/createAsAdmin": "Added member",
    "members/edit": "Edited member",
    "members/archive": "Archived member",
    "projectActions/editPlanned": "Edited project action",
    "projectActions/move": "Project action put on schedule",
    "projectActions/setMovable": "Updated project action",
    "projectActions/setLocation": "Updated location",
    "projectActions/setLocationUnplanned": "Updated location",
    "projectActions/editUnplanned": "Edited unplanned project action",
    "projectActions/removePlanned": "Unplanned project",
    "projects/create": "Added new project",
    "projects/edit": "Updated project",
    "projects/remove": "Deleted project",
    "projects/delete-unplanned": "Deleted all unplanned projects",
    "projects/lockProject": "Locked project",
    "projects/unlockProject": "Unlocked project",
    "projectTemplates/create": "Created new project template",
    "projectTemplates/createDraft": "Created new project template draft",
    "projectTemplates/edit": "Edited project template",
    "projectTemplates/editDraft": "Edited project template draft",
    "projectTemplates/remove": "Deleted project template",
    "whiteTasks/remove": "Deleted task successfully",
    "whiteTasks/create": "Added new task",
    "whiteTasks/edit": "Edited task successfully",
    "whiteTasks/createRecurrence": "Created recurrency",
    "whiteTasks/removeRecurrence": "Removed the recurrent tasks",
    "teamStatus/start": "Entered Simulation Mode",
    "teamStatus/accept": "Simulation Mode changes applied",
    "teamStatus/discard": "Simulation Mode changes discarded",
    "customers/addCustomer": "Added a customer",
    "customers/editCustomer": "Edited the customer",
    "customers/deleteCustomer": "Deleted the customer",
    "team/create-api-token": "Created API token",
    "team/delete-api-token": "Deleted API token"
  },
  "error": {
    "analyses/remove/ERROR": "Failed unplanning analysis",
    "analysisDefinitions/create/ERROR": "Failed adding new analysis definition",
    "analysisDefinitions/remove/ERROR": "Failed deleting analysisdefinition",
    "assets/remove/ERROR": "Failed deleting instrument",
    "assets/create/ERROR": "Failed adding instrument",
    "auth/login/ERROR": "Failed logging in",
    "competenceGroups/create/ERROR": "Failed creating competence group",
    "competenceGroups/remove/ERROR": "Failed deleting competence group",
    "iap/run/ERROR": "Failed running IAP",
    "iap/runFillInSamples/ERROR": "Failed filling in samples",
    "integrationSheets/createActionSheet/ERROR": "Failed adding sheet",
    "integrationSheets/createProjectTemplateSheets/ERROR": "Failed adding sheet",
    "integrationSheets/createSampleSheet/ERROR": "Failed adding sheet",
    "integrationSheets/editActionSheet/ERROR": "Failed editing sheet",
    "integrationSheets/editProjectTemplateSheet/ERROR": "Failed editing sheet",
    "integrationSheets/editSampleSheet/ERROR": "Failed editing sheet",
    "integrationSheets/removeActionSheet/ERROR": "An error occurred when trying to delete sheet",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "An error occurred when trying to delete sheet",
    "integrationSheets/removeSampleSheet/ERROR": "An error occurred when trying to delete sheet",
    "loading/fetchAll/ERROR": "Failed loading",
    "members/create/ERROR": "Failed adding member",
    "members/createAsAdmin/ERROR": "Failed adding member",
    "members/archive/ERROR": "Failed archiving member",
    "projectActions/move/ERROR": "Failed moving action onto schedule",
    "projectActions/removePlanned/ERROR": "Failed unplanning action",
    "projectActions/setLocation/ERROR": "Failed to update location",
    "projectActions/setLocationUnplanned/ERROR": "Failed to update location",
    "projects/create/ERROR": "Failed adding new project",
    "projects/remove/ERROR": "Failed deleting project",
    "projects/delete-unplanned/ERROR": "Failed deleting unplanned projects",
    "projects/lockProject/ERROR": "Failed Locking actions",
    "projectTemplates/create/ERROR": "Failed creating new project template",
    "projectTemplates/createDraft/ERROR": "Failed creating new project template draft",
    "projectTemplates/remove/ERROR": "Failed deleting project template",
    "whiteTasks/remove/ERROR": "Failed deleting task",
    "whiteTasks/create/ERROR": "Failed creating",
    "teamStatus/start/ERROR": "Failed entering Simulation Mode",
    "teamStatus/accept/ERROR": "Failed applying Simulation Mode changes",
    "teamStatus/discard/ERROR": "Failed discarding Simulation Mode changes",
    "customers/deleteCustomer/ERROR": "Could not delete the customer",
    "customers/addCustomer/ERROR": "Could not add the customer",
    "customers/editCustomer/ERROR": "Could not edit the customer",
    "team/create-api-token/ERROR": "Could not create API token",
    "team/delete-api-token/ERROR": "Could not delete API token"
  },
  "adhoc": {
    "welcomeBack": "Welcome back!",
    "noSoundDetected": "No sound detected. Please try again.",
    "noMicrophoneDetected": "No microphone detected. Please try again.",
    "iapRunning": "Just a moment - the IAP for your team is running",
    "failedDiscardNotLoggedOut": "Failed discarding changes. You were not logged out!",
    "cannotDragRecurrentTask": "You cannot drag and drop a recurrent grey task",
    "cannotMoveImportedTasks": "You cannot move imported tasks",
    "noCheckboxesSelected": "No checkboxes selected",
    "analysisUpdatedRefresh": "Analysis updated, please refresh",
    "analysisUpdatedByAnotherUser": "Analysis has been updated by another user, please refresh",
    "copiedToClipboard": "Copied to clipboard",
    "couldNotCopyToClipboard": "Could not copy to clipboard",
    "chooseFirstAction": "Please choose the first {{itemType}}",
    "chooseSecondAction": "Please choose the second {{itemType}}",
    "chooseTwoDifferent": "Please choose two different {{itemType}}",
    "constraintConflicts": "That constraint conflicts with existing ones",
    "sampleCreated": "Sample created",
    "sampleDeleted": "Sample deleted",
    "samplesUpdated": "Samples updated",
    "sampleMarkedDone": "Sample marked as done",
    "memberPermissionsChanged": "Member permissions changed",
    "chooseUniqueName": "Please choose an unique name",
    "fillRequiredFields": "Please fill required fields",
    "couldNotDetermineSampleIdDone": "Could not determine sample id to mark done",
    "couldNotDetermineSampleIdDelete": "Could not determine sample id to delete",
    "couldNotDetermineSampleIdDeleteMissing": "Could not determine sample id to delete — data missing. Check console for details.",
    "anErrorOccurred": "An Error Occurred",
    "selectFileBeforeSubmitting": "Please select at least one file before submitting",
    "helpPageUpdated": "Help page updated",
    "processingStarted": "Processing started",
    "failedLoadingIcalFiles": "Failed loading iCalendar files",
    "unsortBeforePasting": "Please unsort the table before pasting multiple cells.",
    "fillAllRequiredFields": "Please fill in all required fields",
    "unsavedChangesConfirmLeave": "You have unsaved changes. To confirm you want to leave, press the back button again.",
    "provideSheetName": "Please provide a Sheet Name",
    "sheetNameAlreadyExists": "Sheet with that name already exists",
    "provideSheetType": "Please provide a Sheet Type",
    "didNotSpellDeleteProperly": "You did not spell DELETE properly",
    "domainMustStartWithAt": "Domain must start with '@'",
    "fillOutRequiredFields": "Please fill out required fields",
    "selectValidDates": "Please select valid dates",
    "noIapModeSelected": "No IAP mode selected. Please select a mode.",
    "oneCollaboratorForWorkday": "Only one collaborator may be selected when checking the entire workday",
    "fillRequiredDateTimeFields": "Please fill in all required date and time fields",
    "endMustBeAfterStart": "The end of the task must be after the start",
    "recurrencesCannotExceed365": "Number of recurrences cannot be greater than 365",
    "pleaseFillNumberAndInterval": "Please fill out number and interval of recurrences",
    "pleaseFillNumberOfRecurrences": "Please fill out number of recurrences",
    "pleaseFillIntervalOfRecurrences": "Please fill out interval of recurrences",
    "pleaseFillAllPeriodFields": "Please fill out all period fields",
    "pleaseSelectReportType": "Please select at least one report type",
    "reportEmptyInInterval": "The {{fileName}} is empty in the given interval",
    "noSoundDetected": "No sound detected. Please try again.",
    "noMicrophoneDetected": "No microphone detected. Please try again.",
    "promptTooLong": "Prompt too long (max is 1200 characters)",
    "nameTooLong": "Name too long (max is 100 characters)"
  }
}
